import { PendingTasksCard } from "./PendingTasksCard";
import { InProgressCard } from "./InProgressCard";

type TasksActionsProps = {
  /** Entities both cards are scoped to. Empty means the whole group. */
  entityIds: string[];
  /** False until the group's entities have loaded — nothing fetches before then. */
  isScopeReady: boolean;
};

export const TasksActions = ({
  entityIds,
  isScopeReady,
}: TasksActionsProps) => {
  return (
    // Below md the 7/5 split leaves each card too narrow to read, so the cards
    // stack full width instead.
    <div className="t-flex t-flex-col t-gap-6 md:t-grid md:t-grid-cols-12 md:t-items-start">
      <div className="md:t-col-span-7">
        <PendingTasksCard entityIds={entityIds} isScopeReady={isScopeReady} />
      </div>
      <div className="md:t-col-span-5">
        <InProgressCard entityIds={entityIds} isScopeReady={isScopeReady} />
      </div>
    </div>
  );
};
